<template>
<div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-dark">
    </base-header>
    <card>
        <b-container fluid class="mt--6">

            <!-- </b-container>
         <b-container fluid> -->
            <br />
            <div>
                <!-- <div > -->
                <validation-observer v-slot="{ invalid }">
                    <b-form @submit.prevent="SimpanMaklumat">
                        <card header-classes="bg-transparent">
                            <h3 class="mb-0">Maklumat Penjawat Awam</h3>
                            <br />
                            <div class="pl-lg-4">
                                <validation-provider name="NoKP" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row class="my-1">
                                        <b-col sm="3"> No. Kad Pengenalan </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="3" v-if="ProfilAwam.NoKP">{{ ProfilAwam.NoKP }}</b-col>
                                        <b-col sm="8" v-else>
                                            <b-form-input v-model="ProfilAwam.NoKP" disabled="disabled"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <validation-provider name="NAMA" :rules="{ required: true}" v-slot="validationContext">
                                    <b-row class="my-1">
                                        <b-col sm="3"> Nama </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="8">
                                            <!-- <base-input id="Nama" placeholder="" v-model="ProfilAwam.Nama" :rules="{ required: true}" name="Nama" /> -->
                                            <b-form-input v-model="ProfilAwam.Nama" :state="getValidationStatePenjawat(validationContext)" disabled="disabled"></b-form-input>
                                            <b-form-invalid-feedback id="input-2-live-feedback">{{
                                                validationContext.errors[0]
                                            }}</b-form-invalid-feedback>
                                        </b-col>
                                    </b-row>
                                </validation-provider>

                                <validation-provider name="Klasifikasi Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row>
                                        <b-col sm="3"> Klasifikasi Perkhidmatan Pertama </b-col>
                                        <b-col sm="1"> :</b-col>
                                        <b-col sm="8">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" :state="getValidationStatePenjawat(validationContext)" v-model="ProfilAwam.ServClassId" :options="ServClassList" @change="runMethod()" style="width: 50%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="input-2-live-feedback">{{
                                                validationContext.errors[0]
                                            }}</b-form-invalid-feedback>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <validation-provider name="Skim Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row>
                                        <b-col sm="3"> Skim Perkhidmatan</b-col>
                                        <b-col sm="1"> :</b-col>
                                        <b-col sm="8">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ProfilAwam.SchmOfServId" :options="SchmOfServList" @change="runMethod2()" style="width: 60%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>

                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <b-row class="my-1">

                                </b-row>
                                <validation-provider name="Gred Jawatan Lantikan Pertama" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row class="my-1">
                                        <b-col sm="3"> Gred Jawatan Lantikan Pertama </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="3">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ProfilAwam.SalGrdID" :options="SalGrdList" :state="getValidationStatePenjawat(validationContext)" style="width: 60%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="input-2-live-feedback">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <b-row class="my-1">

                                </b-row>
                                <validation-provider name="Gaji Lantikan Pertama" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row class="my-1">
                                        <b-col sm="3"> Gaji Lantikan Pertama </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="2">
                                            <!-- <base-input id="Gaji Lantikan Pertama" placeholder="" v-model="ProfilAwam.GajiLantikan" :rules="{ required: true }" name="Gaji Lantikan Pertama" /> -->
                                            <b-form-input v-model="ProfilAwam.SalGrdPertama" :rules="{ required: true }" :state="getValidationStatePenjawat(validationContext)" aria-describedby="input-2-live-feedback"></b-form-input>
                                            <b-form-invalid-feedback id="input-2-live-feedback">{{
                                            validationContext.errors[0]
                                        }}</b-form-invalid-feedback>
                                        </b-col>
                                    </b-row>

                                </validation-provider>
                                <b-row class="my-1">

                                </b-row>
                                <validation-provider name="Tarikh Lantikan Pertama" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row class="my-1">
                                        <b-col sm="3"> Tarikh Lantikan Pertama </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="4">

                                            <base-input type="date" v-model="ProfilAwam.DtLantikanPertama" size="sm"></base-input>
                                        </b-col>
                                    </b-row>
                                </validation-provider>

                                <validation-provider name="Tarikh Dijangka Bersara" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row class="my-1">
                                        <b-col sm="3"> Tarikh Dijangka Bersara </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="4">

                                            <base-input type="date" v-model="ProfilAwam.DtJangkaPencen" size="sm"></base-input>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <validation-provider name="Layak Menerima KGT Khas 2023" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row class="my-1">
                                        <b-col sm="3"> Layak Menerima KGT Khas 2023 </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="4">
                                            <b-form-group v-slot="{ ariaDescribedby }">
                                                <b-form-radio v-model="ProfilAwam.StatusKGT2023" :aria-describedby="ariaDescribedby" name="some-radios" value="1">YA</b-form-radio>
                                                <b-form-radio v-model="ProfilAwam.StatusKGT2023" :aria-describedby="ariaDescribedby" name="some-radios" value="2">TIDAK</b-form-radio>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <validation-provider name="Tarikh Dijangka Bersara" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row class="my-1">
                                        <b-col sm="3"> Meninggal Dunia </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="4">
                                            <b-form-group v-slot="{ ariaDescribedby }">
                                                <b-form-radio-group id="btn-radios-1" v-model="StatusMeninggalDunia" :options="options" :aria-describedby="ariaDescribedby" name="radios-stacked" stacked></b-form-radio-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <div v-if="StatusMeninggalDunia == 1">
                                    <b-row class="my-1">
                                        <b-col sm="3"> Tarikh Meninggal Dunia </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="4">
                                            <base-input type="date" v-model="ProfilAwam.DtMeninggalDunia" size="sm"></base-input>
                                        </b-col>
                                    </b-row>

                                </div>

                            </div>
                            <b-col>&nbsp;</b-col>
                            <b-form-row>
                                <b-col>
                                    <b-form-group>
                                        <div>
                                            <b-col>&nbsp;</b-col>
                                            <b-col align="center">
                                                <b-button variant="success" type="submit" :disabled="invalid" v-show="simpa2">SIMPAN</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="ToPagePapar()">KEMASKINI MAKLUMAT</b-button>
                                                <b-button size="md" variant="danger" v-show="active" @click="next()">SETERUSNYA</b-button>
                                            </b-col>
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                        </card>
                    </b-form>
                </validation-observer>
            </div>
        </b-container>
    </card>

</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    data() {
        return {
            StatusMeninggalDunia: 0,
            StatusKGT2023: 1,
            form: {
                NoKP: this.NoKP,
            },
            statuspemanggil: {
                Status: 2
            },
            status: {

            },
            ProfilAwam: {
                //StatusKGT2023: 1,
                // Nama: null,
            },
            selectedKlasPerkhidmatan: null,
            selectedSkimPerkhidmatan: null,
            selectedSalGrd: null,
            ServClassList: [{
                    value: 1,
                    text: 'test 1'
                },
                {
                    value: 2,
                    text: 'test 2'
                },
            ],
            SchmOfServList: [],
            SalGrdList: [],
            active: false,
            simpa2: true,
            options: [{
                    text: 'YA',
                    value: '1'
                },
                {
                    text: 'TIDAK',
                    value: '0'
                }
            ],
        }

    },
    methods: {
        getValidationStatePenjawat({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },
        runMethod() {
            console.log("klas perkhidmatan", this.ServClassId);

            let Search = {
                ServClassId: this.ProfilAwam.ServClassId,
            };

            GetselenggaraService.getSenaraiSchmOfServ(Search)
                .then((resp) => {
                    this.SchmOfServList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        runMethod2() {

            let Search = {
                ServClassId: this.ProfilAwam.ServClassId,
                SchmOfServId: this.ProfilAwam.SchmOfServId,
            };

            console.log("search", this.Search);

            GetselenggaraService.getSenaraiSalGrd(Search)
                .then((resp) => {
                    this.SalGrdList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        SimpanMaklumat() {

            console.log("sebeleu", this.ProfilAwam);
            this.$store.commit('clearAll');
            this.ProfilAwam.StatusMeninggalDunia = this.StatusMeninggalDunia;
            this.$store.commit("addMaklumatPeribadi", this.ProfilAwam);

            this.simpa2 = false;
            this.active = true;
            console.log("ProfilAwam: ", this.ProfilAwam);
        },

        ToPagePapar() {

            this.$router.push({
                name: 'MAKLUMAT KIRA GAJI',
            })
        },

    },

    computed: {
        MaklumatPeribadiInStore() {
            return Store.state.MaklumatPeribadi;

            console.log("ini store", Store.state.MaklumatPeribadi);

        },

    },

    created() {

        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log("SERVE",this.ServClassList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSchmOfServ()
            .then((resp) => {
                this.SchmOfServList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSalGrd()
            .then((resp) => {
                this.SalGrdList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        this.ProfilAwam = this.$store.state.MaklumatPeribadi;

    }
}
</script>
